import type { FutureStockQuantities } from '../types';

const getFutureStocksAfterQuantityReductions = (
    futureStock?: FutureStockQuantities,
    quantityToIgnore = 0
) => {
    if (!futureStock || quantityToIgnore === 0) {
        return { futureStock, quantityToIgnore };
    }

    let quantityLeftToIgnore = quantityToIgnore;
    const newFutureStock: FutureStockQuantities = {
        ...futureStock,
        quantities: [],
    };

    for (const stock of futureStock.quantities) {
        if (quantityLeftToIgnore === 0 || !stock.quantity) {
            quantityLeftToIgnore = 0;
            newFutureStock.quantities.push(stock);
        } else if (stock.quantity > quantityLeftToIgnore) {
            newFutureStock.quantities.push({
                ...stock,
                quantity: stock.quantity - quantityLeftToIgnore,
            });

            quantityLeftToIgnore = 0;
        } else {
            newFutureStock.quantities.push({
                ...stock,
                quantity: 0,
            });

            quantityLeftToIgnore -= stock.quantity;
        }
    }

    return {
        futureStock: newFutureStock,
        quantityToIgnore: quantityLeftToIgnore,
    };
};

export default getFutureStocksAfterQuantityReductions;
